import reset from "styled-reset";
import { createGlobalStyle, css } from "styled-components";

const GlobalStyle = createGlobalStyle` 
@font-face {
  font-family: NotoSans;
  font-weight: 400;
  src: url(${require("./fonts/NotoSans-Regular.otf")}) format("truetype");
}
@font-face {
  font-family: NotoSans;
  font-weight: 500;
  src: url(${require("./fonts/NotoSans-Medium.otf")}) format("truetype");
}
@font-face {
  font-family: NotoSans;
  font-weight: 700;
  src: url(${require("./fonts/NotoSans-Bold.otf")}) format("truetype");
}

  * {
    box-sizing: border-box;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    
    ::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera*/
    }
  }
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, sub, sup, tt, var,
  u, i, center, dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video , button, input,
  select, textarea {
    ${(props) => {
      if (props.os === "android") {
        return css`
          font-family: NotoSans, Roboto, Helvetica, Arial, sans-serif;
        `;
      } else {
        return css`
          font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue",
            Helvetica, Arial, sans-serif;
        `;
      }
    }};
  }
`;

export default GlobalStyle;
